import React from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { Buttons, ButtonWrap, Icon } from './style';
import { BUTTON_TYPE } from '../../../global/constants';

interface Props {
  title?: string;
  onClick?: any;
  isLoading?: boolean;
  disabled?: boolean;
  variant: number;
  buttonType?: 'reset' | 'submit' | 'button';
  size?: 'small' | 'medium' | 'large';
  iconPosition?: 'start' | 'end' | 'none';
  iconName?: string;
  iconViewBox?: string;
  className?: string;
}

const ButtonV2: React.FC<Props> = (Props) => {
  const {
    title,
    onClick,
    size = 'medium',
    buttonType = 'button',
    variant = BUTTON_TYPE.PRIMARY,
    iconName,
    iconPosition,
    iconViewBox = '0 0 18 18',
    className,
    isLoading,
    disabled,
    ...props
  } = Props;

  return (
    <ButtonWrap isLoading={isLoading} className={className}>
      <Buttons
        variant={variant}
        disabled={disabled || isLoading}
        isLoading={isLoading}
        size={size}
        iconPosition={iconPosition}
        onClick={onClick}
        type={buttonType}
        className={className}
        {...props}>
        {iconName && (
          <Icon size={size} variant={variant} disabled={disabled || isLoading}>
            <SVGIcon name={iconName} height='18' width='18' fill='var(--text-white)' viewBox={iconViewBox} />
          </Icon>
        )}
        {title || ''}
      </Buttons>
    </ButtonWrap>
  );
};

export default ButtonV2;
